export { a as DIR_DOCUMENT, D as Directionality } from './directionality-0a678adc.mjs';
export { B as BidiModule, D as Dir } from './bidi-module-56dd006c.mjs';
import '@angular/core';
import '@angular/common';
